import auth from 'Services/auth';

const useUser = () => auth.getUser();

export default useUser;
